<div class="close closeModal">
  <a (click)="close()" title="cerrar"
    ><span class="cross"></span><span class="sr-only">cerrar</span></a
  >
</div>
<div class="aviso facturacion">
  <div class="tituloSearch">{{ 'CONFIGURAR_ETIQUETAS' | translateV2 }}</div>
  <div class="avisoInputWrap" [formGroup]="etiquetaForm">
    <div class="form-row">
      <div class="form-group">
        <div class="tit-form-group">
          <label for="localizador">{{ 'LOCALIZADOR' | translateV2 }}</label>
        </div>
        <input
          [readonly]="true"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="localizador"
          formControlName="localizador"
        />
      </div>
      <div class="form-group">
        <div class="tit-form-group">
          <label for="integrantes">{{ 'NUMERO_INTEGRANTES' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="integrantes"
          formControlName="integrantes"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group" (click)="openModal('datePickEtiquetas')">
        <div class="tit-form-group">
          <label for="fecha">{{ 'FECHA' | translateV2 }}</label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="fecha"
          formControlName="fecha"
        />
      </div>
      <div class="form-group">
        <div class="tit-form-group">
          <label for="horaMaxima">{{ 'HORA_EMISION' | translateV2 }}</label>
        </div>
        <input
          [readonly]="true"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="horaEmision"
          formControlName="horaEmision"
        />
      </div>
      <div class="form-group">
        <div class="tit-form-group">
          <label for="hora">{{ 'HORA' | translateV2 }}</label>
        </div>
        <div class="form-row">
          <a class="prev" title="Previo" (click)="bajarHora()">
            <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
          </a>
          <input
            category="ALFANUMERICO"
            value="hora"
            (focus)="focusValue($event)"
            type="text"
            class="form-control"
            id="hora"
            formControlName="hora"
          />
          <a class="next" title="Previo" (click)="subirHora()">
            <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
          </a>
        </div>
      </div>

      <div class="form-group">
        <div class="tit-form-group">
          <label for="hora">{{ 'MINUTOS' | translateV2 }}</label>
        </div>
        <div class="form-row">
          <a class="prev" title="Previo" (click)="bajarMinutos()">
            <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
          </a>
          <input
            category="ALFANUMERICO"
            (focus)="focusValue($event)"
            type="text"
            class="form-control"
            id="minutos"
            formControlName="minutos"
          />
          <a class="next" title="Previo" (click)="subirMinutos()">
            <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
          </a>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <div class="tit-form-group">
          <label for="textoManual">
            {{ 'TEXTO_MANUAL' | translateV2 }}
          </label>
        </div>
        <input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="textoManual"
          formControlName="textoManual"
        />
      </div>
    </div>
  </div>
  <div class="faturacion-fila">
    <div class="ticket-info">
      <div class="inputControl botones">
        <button type="button" value="cancelar" class="cancelar" (click)="close()">
          {{ 'CANCELAR' | translateV2 }}
        </button>
      </div>
    </div>
    <div class="ticket-info">
      <div class="inputControl botones">
        <button
          type="button"
          value="ACEPTAR"
          class="pagar aceptar"
          (click)="imprimirEtiquetas()"
          [disabled]="etiquetaForm.invalid"
        >
          {{ 'ACEPTAR' | translateV2 }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="keyboardWrap">
  <ticketing-keyboard></ticketing-keyboard>
  <ticketing-numpad></ticketing-numpad>
</div>
